import React from "react";

export default function HeadingStandard({ section }) {
  const { title, paragraph } = section?.content || {};

  return (
    <section className="wrapper">
      <div className="contact-section-four pt-50 pt-md-100">
        <div className="container">
          <div className="row">
            <div className="col-xxl-9 col-xl-10 col-lg-8 col-md-10 m-auto">
              <div className="title-style-one text-center">
                <h2 className="title">{title}</h2>
                <p className="text-lg pt-30 lg-pt-20 preWrap">{paragraph}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
